<template>
  <div id="ReceiptBackup">
    <BreadCrumb :items="breadcrumbItemsByRole" />

    <v-card elevation="1" class="pt-5 px-5 mt-1">
      <div class="header d-flex justify-space-between align-center">
        <h1 class="px-0">Exportações de Canhotos em Imagens</h1>
      </div>

      <div class="d-flex my-5">
        <v-icon class="pr-1">mdi-information-outline</v-icon>
        <div class="info-message">Atenção, apenas os últimos 5 registros serão mantidos.</div>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="backupRequests"
          :loading="isLoading"
          :footer-props="{
            'items-per-page-options': [],
            itemsPerPageText: '100'
          }"
          disable-pagination
          no-data-text="Nenhum resultado encontrado"
        >
          <template v-slot:[`item.createdAt`]="{ item }">
            {{ transformDate(item.createdAt) }}
          </template>
          <template v-slot:[`item.nfeNumber`]="{ item }">
            <copy-to-clipboard-tooltip should-copy :text="transformNfes(item.nfeNumber)"></copy-to-clipboard-tooltip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div>
              <DownloadBackupButton :id="item.id" @feedbackReceive="onFeedbackReceive" />
            </div>
          </template>
        </v-data-table>
        <div class="d-flex align-center py-3">
          <v-pagination v-model="pageNumber" :length="totalPages" :total-visible="7"></v-pagination>
          <reload-button @click="getReceiptBackupList" />
        </div>
      </div>
    </v-card>
    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import { mapActions, mapGetters } from 'vuex';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';
import MessagesError from '@/components/MessagesError.vue';
import DownloadBackupButton from './DownloadBackupButton.vue';
import CopyToClipboardTooltip from '@/components/CopyToClipboardTooltip.vue';
import ReloadButton from '@/components/ReloadButton';
import { Roles } from '@/consts/Roles';
import { hasPermission } from '@/utils/hasPermission';
export default {
  name: 'ReceiptsBackup',
  components: {
    MessagesError,
    BreadCrumb,
    DownloadBackupButton,
    CopyToClipboardTooltip,
    ReloadButton
  },
  data: () => ({
    isInitialDateMenuOpen: false,
    isEndDateMenuOpen: false,
    initialDate: null,
    endDate: null,
    backupRequests: [],
    isLoading: false,
    totalPages: 1,
    pageNumber: 1,
    pageSize: 10,
    errors: [],
    errorsType: 'error',
    headers: [
      { text: 'DATA DE SOLICITAÇÃO', value: 'createdAt', align: 'start' },
      { text: 'EXPORTADO POR', value: 'userName' },
      { text: 'NFES', value: 'nfeNumber' },
      { text: 'STATUS', value: 'status' },
      { text: 'AÇÕES', value: 'actions' }
    ],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start',
        role: [Roles.SHIPPER, Roles.ADMIN]
      },
      {
        text: 'Backup de canhotos',
        disabled: true,
        to: '/receipts-backup',
        role: [Roles.SHIPPER]
      },
      {
        text: 'Exportações',
        disabled: true,
        role: [Roles.ADMIN]
      },
      {
        text: 'Canhotos em Imagens',
        disabled: true,
        role: [Roles.ADMIN]
      }
    ]
  }),

  computed: {
    ...mapGetters('LoginStore', ['getUserLogged', 'getRole']),

    formattedDate() {
      if (!this.initialDate) return '';
      const [year, month, day] = this.initialDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.endDate) return '';
      const [year, month, day] = this.endDate.split('-');
      return `${day}/${month}/${year}`;
    },
    breadcrumbItemsByRole() {
      const roles = this.getRole;
      return this.breadcrumbItems.filter((item) => hasPermission(item.role, roles));
    }
  },

  created() {
    this.getReceiptBackupList();
    this.handleFeedback();
  },

  methods: {
    ...mapActions('ShippersStore', ['getBackupList', 'downloadBackup']),
    async getReceiptBackupList() {
      try {
        this.isLoading = true;
        const data = await this.getBackupList();
        this.backupRequests = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onDownloadClick(backupId) {
      try {
        await this.downloadBackup(backupId);
      } catch (error) {
        console.error(error);
      }
    },
    handleFeedback() {
      const message = FeedbackMessageHandler.getFeedbackMessage(this);
      if (message) {
        this.errorsType = 'success';
        this.errors = [message];
        FeedbackMessageHandler.resetFeedbackMessage(this);
      }
    },
    transformNfes(nfes) {
      return nfes.join(', ');
    },
    transformDate(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    },
    onFeedbackReceive({ errorsType, message }) {
      this.errorsType = errorsType;
      this.errors = [message];
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
</style>
